<template>
  <main role="PesananDetail">
    <div class="row">
      <div class="col-xl-9">

       <SkeletonTemplate v-if="Skeleton"/>
       <SkeletonTemplate v-if="Skeleton"/>

        <ModalRefuseOrder :reasonTypeRejectOrder="reasonTypeRejectOrder" :refuseOrder="refuseOrder"/>

        <WizardPesanan
          :arrivedOrder="arrivedOrder"
          :openModalRefuseOrder="openModalRefuseOrder"
          :refuseOrder="refuseOrder"
          :sendOrder="sendOrder"
          :confirmOrder="confirmOrder"
          :renderComponent="renderComponent"
          :processingColumn="processingColumn"
          :processingData="processingData"
          :shipping="shipping"
          :orderSummary="orderSummary"
          :orderSummaryCol="orderSummaryCol"
          :itemsRequestChange="itemsRequestChange"
          :acceptRequestChange="acceptRequestChange"
          :rejectRequestChange="rejectRequestChange"
          :acceptApplyCancel="acceptApplyCancel"
          :rejectApplyCancel="rejectApplyCancel"
          :createComplaint="createComplaint"
          :complaintData="complaintData"
          :orderStatusId="orderStatusId"
          :Skeleton="Skeleton"
          :isProductUncategorized="isProductUncategorized"
        >
        </WizardPesanan>

        <template v-if="countConfirmPayment !== 0">
          <ConfirmPayment :confirmPayment="confirmPayment"></ConfirmPayment>
        </template>

        <template v-if="countsectionConfirmPayment !== 0">
          <InformationConfirmPayment
            :sectionConfirmPayment="sectionConfirmPayment"
          ></InformationConfirmPayment>
        </template>

        <template>
          <Invoice
            :invoice="invoice"
            :paymentMethod="paymentMethod"
            :mall="mall"
            :shipping="shipping"
            :school="school"
            :orderSummary="orderSummary"
            :orderSummaryCol="orderSummaryCol"
            :descriptionTotal="descriptionTotal"
            :orderStatusId="orderStatusId"
          >
          </Invoice>
        </template>
      </div>

      <div class="col-xl-3">
        <SkeletonTemplate v-if="Skeleton"/>
        <SkeletonTemplate v-if="Skeleton"/>
        <!-- <div class="card" v-if="eBastCount !== 0 || !processingData.isEbast"> -->
        <div class="card" v-if="printDocuments.length > 0">
          <div class="card-header">
            <h4 class="card-title">Dokumen</h4>
            <!-- <button class="btn btn-danger" @click="testSwal">Test</button> -->
          </div>
          <div class="card-body">
            <div class="mb-3" v-if="isUploadTax">
              <form enctype=multipart/form-data @input="postPhotoPajak">
                <label for="uploadPajak" class="form-label font-weight-bold">Upload Bukti Pajak</label>
                <input class="form-control" type="file" id="uploadPajak">
              </form>
            </div>
            <template v-for="(print, index) in printDocuments">
              <button
                :class="
                  print.value === 'printEbast'
                    ? 'btn col btn-outline-default bg-transparent text-dark'
                    : print.value === 'printFaktur'
                    ? 'btn col btn-outline-default bg-transparent text-dark'
                    : print.name === 'Shipping Label'
                    ? 'btn col btn-outline-default bg-transparent text-dark'
                    : print.name === 'Cetak PO'
                    ? 'btn col btn-outline-default bg-transparent text-dark'
                    : 'btn col btn-outline-default bg-transparent text-dark'
                "
                :id="print.value"
                @click="putPrint(print.value, print.url)"
                :key="index"
              >
                <i class="fas fa-file-alt pull-left mt-1 mb-1"></i>
                {{ print.name }}
              </button>
            </template>
            <!-- <button class="btn col btn-success">
              <i class="fas fa-file-alt pull-left mt-1 mb-1"></i> Print Kwitansi
            </button> -->
          </div>
        </div>
        <PaymentHistory v-if="paymentHistory.length != 0" :paymentHistory="paymentHistory"></PaymentHistory>
        <Complaint :orderStatusId="orderStatusId" :isSendComplaint="isSendComplaint" :addComplaint="addComplaint" 
        :processingData="processingData" :loadingState="loadingState" :resolveComplaint="resolveComplaint" :createComplaint="createComplaint" :sectionOrderInformation="invoice" :complaintData="complaintData"></Complaint>
        <OrderHistory
          :orderTracking="orderTracking"
          :orderTimeline="orderTimeline"
          :shipping="shipping"
          :statusDibatalkan="statusDibatalkan"
          :openTracking="openTracking"
          :isOpenTracking="isOpenTracking"
          :isFetching="isFetching"
          :isTracking="isTracking"
          :rejectReason="rejectReason"
        ></OrderHistory>
      </div>
    </div>
  </main>
</template>

<script>
import SkeletonTemplate from "../../skeleton/SkeletonTemplate.vue";
import Invoice from "./InvoiceDetailPesanan";
import WizardPesanan from "./wizardPesanan";
import OrderHistory from "./OrderHistory";
import ConfirmPayment from "./ConfirmPayment";
import Complaint from "./Complaint";
import PaymentHistory from "./PaymentHistory";
import InformationConfirmPayment from "./InformationConfirmPayment";
import axios from "axios";
import $ from "jquery";
import { imagePopup } from "/src/utils/imagePopup.js";

import cancelAnimation from "/src/assets/animations/cancelAnimation.json";
import confirmAnimation from "/src/assets/animations/confirmAnimation.json";
import sendAnimation from "/src/assets/animations/sendAnimation.json";
import arrivedAnimation from "/src/assets/animations/arrivedAnimation.json";
import ModalRefuseOrder from '../../../components/seller/Pesanan/ModalRefuseOrder.vue'
// import { sleeper } from "/src/utils/sleeper.js";

export default {
  components: {
    SkeletonTemplate,
    Invoice,
    WizardPesanan,
    OrderHistory,
    InformationConfirmPayment,
    ConfirmPayment,
    Complaint,
    PaymentHistory,
    ModalRefuseOrder
  },

  data() {
    return {
      renderComponent: true,
      processingColumn: {},
      orderTimeline: {},
      orderDetail: {},
      processingData: {},
      statusDibatalkan: [],
      confirmPayment: {},
      countConfirmPayment: "",
      countsectionConfirmPayment: "",
      sectionConfirmPayment: {},
      printDocuments: {},
      eBastCount: "",
      invoice: {},
      paymentMethod: {},
      mall: {},
      shipping: {},
      school: {},
      orderSummary: {},
      orderSummaryCol: {},
      descriptionTotal: {},
      complaintData: [],
      isNewOrder: false,
      animation: {
        confirmOrder: confirmAnimation,
        cancelOrder: cancelAnimation,
        sendOrder: sendAnimation,
        arriverOrder: arrivedAnimation,
      },
      Skeleton: true,
      orderTracking: [],
      isOpenTracking: false,
      isFetching: false,
      isTracking: false,
      isUploadTax: true,
      itemsRequestChange: "",
      orderStatusId: "",
      isSendComplaint: false,
      paymentHistory: [],
      isProductUncategorized:false,
      loadingState:false,
      rejectReason:"",
      reasonTypeRejectOrder:[]
    };
  },
  created() {
    this.getOrderDetail();
    this.getOrderTracking();
    $(".skype-loader").hide();
  },
  beforeUpdate() {
    let ifResolved = "";
    let complainDt = this.complaintData
    complainDt.forEach((element) => (ifResolved += element.isResolved));

    if (
      this.complaintData.length != 0 &&
      !$("#complaintModal").hasClass("show") &&
      ifResolved.includes("false")
    ) {
      this.alertIfHasComplain();
    }
  },
  methods: {
    scrollComplaint() {
      $("#complainButton").on("click", function () {
        setTimeout(() => {
          $(".scrollable")
            .stop()
            .animate(
              {
                scrollTop: $(".scrollable")[0].scrollHeight,
              },
              600
            );
        }, 600);
      });
    },
    addComplaint(negoId) {
      this.loadingState = true
      axios
        .post("seller/complaint", {
          id: negoId,
          message: $("#inputComplaint").val(),
        })
        .then(() => {
          // console.log($("#complaintModal").hasClass("show"));
          $("#inputComplaint").val("");
          setTimeout(() => {
            $(".scrollable")
              .stop()
              .animate(
                {
                  scrollTop: $(".scrollable")[0].scrollHeight,
                },
                600
              );
          }, 600);
          setTimeout(() => {
            this.getOrderDetail();
            this.loadingState = false
          }, 550);
        });
    },
    resolveComplaint(complaintMain) {
      this.$swal
        .fire({
          title: "<span style='font-size:17px'>Anda Yakin?</span>",
          html: `<span style='font-size:15px'>Bahwa komplain '<b>${complaintMain}</b>' telah terpenuhi?</span>`,
          icon: "warning",
          showCancelButton: true,
          width: 450,
          confirmButtonColor: "#556ee6",
          cancelButtonColor: "#f46a6a",
          cancelButtonText: "Tidak",
          confirmButtonText: "Ya",
        })
        .then((result) => {
          if (result.isConfirmed) {
            let timerInterval = timerInterval;
            this.$swal.fire({
              title:
                "<span style='font-size:17px'>Menyelesaikan Komplain</span>",
              html: "Mohon Tunggu!",
              allowOutsideClick: false,
              allowEscapeKey: false,
              width: 350,
              didOpen: () => {
                this.$swal.showLoading();
                timerInterval = setInterval(() => {
                  const content = this.$swal.getContent();
                  if (content) {
                    const b = content.querySelector("b");
                    if (b) {
                      b.textContent = this.$swal.getTimerLeft();
                    }
                  }
                }, 100);
              },
            });
            axios
              .put("seller/complaint/resolve", {
                orderId: this.$route.params.id,
                solution:
                  "Saya pihak toko menyatakan, bahwa komplain ini telah selesai",
              })
              .then(() => {
                this.renderComponent = false;
                this.$nextTick(() => {
                  // Add the component back in
                  this.renderComponent = true;
                  this.getOrderDetail();
                });
                setTimeout(() => {
                  this.getOrderDetail();
                  this.$swal.close();
                  $("#complaintModal").modal("hide");
                  this.$swal.fire(
                    "Berhasil!",
                    "Komplain telah selesai",
                    "success"
                  );
                });
              });
          }
        });
    },
    createComplaint() {
      let formData = new FormData();
      let gthis = this;

      let nullPicture = new File([null], null, {
        type: "image/jpeg",
      });

      formData.append("orderId", this.$route.params.id);
      formData.append("category", 0);
      formData.append("reason", $("#complaintReason").val());

      formData.append(
        "fileName",
        document.getElementById("complaintPicture").files.length === 0
          ? nullPicture
          : document.getElementById("complaintPicture").files[0],
        document.getElementById("complaintPicture").files.length === 0
          ? nullPicture.name
          : document.getElementById("complaintPicture").files[0].name
      );

      if ($("#complaintReason").val() === "") {
        gthis.$swal.fire({
          timer: 2000,
          title:
            "<span class='text-muted font-weight-light' style='font-size:17px'>Komplain Tidak Boleh Kosong</span>",
          icon: "warning",
          showConfirmButton: false,
          width: 350,
        });
      } else {
        let timerInterval = timerInterval;
        this.$swal.fire({
          title: "Mengirim Komplain",
          html: "Mohon Tunggu!",
          allowOutsideClick: false,
          allowEscapeKey: false,
          width: 350,
          didOpen: () => {
            this.$swal.showLoading();
            timerInterval = setInterval(() => {
              const content = this.$swal.getContent();
              if (content) {
                const b = content.querySelector("b");
                if (b) {
                  b.textContent = this.$swal.getTimerLeft();
                }
              }
            }, 100);
          },
        });
        axios
          .post("seller/complaint/create", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then(() => {
            this.$swal.fire(
              "Berhasil!",
              "Membuat komplain ke sekolah",
              "success"
            );
            // $("#complaintToSchool").modal("hide");
            this.renderComponent = false;
            this.$nextTick(() => {
              // Add the component back in
              this.$swal.close();
              this.renderComponent = true;
              this.getOrderDetail();
            });
          });
      }
    },
    postPhotoPajak() {
      let timerInterval;
      let formData = new FormData();

      formData.append(
        "file",
        document.querySelector("#uploadPajak").files[0],
        document.querySelector("#uploadPajak").files[0].name
      );
      formData.append("orderId", this.$route.params.id);

      axios
        .post("seller/order/uploadTax", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          this.$swal.fire({
            title: "Proccessing...",
            html: `Bukti pajak sedang diproses`,
            timer: 1500,
            timerProgressBar: false,
            width: 400,
            padding: "2em",
            // heightAuto: true,
            didOpen: () => {
              this.$swal.showLoading();
              timerInterval = setInterval(() => {
                const content = this.$swal.getContent();
                if (content) {
                  const b = content.querySelector("b");
                  if (b) {
                    b.textContent = this.$swal.getTimerLeft();
                  }
                }
              }, 1500);
            },
            willClose: () => {
              clearInterval(timerInterval);
              this.getOrderDetail();
              if (res.data.status.code === 400) {
                this.$swal.fire(
                  `<span style='font-size:17px'>Failed</span>`,
                  res.data.status.message,
                  "error"
                );
              } else {
                this.$swal.fire(
                  `<span style='font-size:17px'>Success</span>`,
                  res.data.status.message,
                  "success"
                );
              }
            },
          });
        });
    },
    arrivedOrder() {
      this.$swal
        .fire({
          title: `<span style='font-size:17px'>Anda Yakin?</span>`,
          text: "Anda menyatakan bahwa pesanan ini telah sampai ke sekolah?",
          icon: "question",
          showCancelButton: true,
          width: 450,
          confirmButtonColor: "#556ee6",
          cancelButtonColor: "#f46a6a",
          cancelButtonText: "Tidak",
          confirmButtonText: "Ya",
        })
        .then((result) => {
          if (result.isConfirmed) {
            let timerInterval = timerInterval;
            this.$swal.fire({
              // title: `<span style='font-size:14px' >Mohon Tunggu</span>`,
              html: `<lottie-player id="arrivedPlayer"  background="transparent"  speed="1"  style="width: 300px; height: 250px;" autoplay loop></lottie-player><h5 style="margin-top:-40px"  class="mb-5">Sedang Diproses, Mohon tunggu...</h5>`,
              allowOutsideClick: true,
              showConfirmButton: false,
              allowEscapeKey: false,
              width: "auto",
              padding: "1em",
              // timer:3000,
              didOpen: () => {
                const player = document.querySelector("#arrivedPlayer");
                player.load(this.animation.arriverOrder);
                // this.$swal.showLoading();
                timerInterval = setInterval(() => {
                  const content = this.$swal.getContent();
                  if (content) {
                    const b = content.querySelector("b");
                    if (b) {
                      b.textContent = this.$swal.getTimerLeft();
                    }
                  }
                }, 100);
              },
            });
            axios
              .put("seller/order/arrived/", {
                id: this.$route.params.id,
              })
              .then(() => {
                this.$swal.close();
                this.$swal.fire({
                  // title: `<span style='font-size:17px'>Berhasil</span>`,
                  title: `<span style='font-size:14px' >Anda berhasil menyatakan bahwa pesanan ini telah sampai ke sekolah</span>`,
                  icon: "success",
                  // html: `<lottie-player src="https://assets6.lottiefiles.com/private_files/lf30_cp81xtth.json"  background="transparent"  speed="1.3"  style="width: 370px; height: 150px;"    autoplay></lottie-player><h5  class="mb-5">Anda berhasil melakukan konfirmasi pesanan</h5>`,
                  // allowOutsideClick: false,
                  // allowEscapeKey: false,
                  // width: 'auto',
                  padding: "1em",

                  showConfirmButton: false,
                  timer: 3000,
                });
                this.renderComponent = false;
                this.$nextTick(() => {
                  // Add the component back in
                  this.renderComponent = true;
                  this.getOrderDetail();
                });
              });
          }
        });
    },
    testSwal() {
      let timerInterval = timerInterval;
      this.$swal.fire({
        // title: `<span style='font-size:14px' >Mohon Tunggu</span>`,
        html: `<lottie-player id="arrivedPlayer"  background="transparent"  speed="1"  style="width: 300px; height: 250px;" autoplay loop></lottie-player><h5 style="margin-top:-40px"  class="mb-5">Sedang Diproses, Mohon tunggu...</h5>`,
        allowOutsideClick: true,
        showConfirmButton: false,
        allowEscapeKey: false,
        width: "auto",
        padding: "1em",
        // timer:3000,
        didOpen: () => {
          const player = document.querySelector("#arrivedPlayer");
          player.load(this.animation.arriverOrder);
          // this.$swal.showLoading();
          timerInterval = setInterval(() => {
            const content = this.$swal.getContent();
            if (content) {
              const b = content.querySelector("b");
              if (b) {
                b.textContent = this.$swal.getTimerLeft();
              }
            }
          }, 100);
        },
      });
    },
    getOrderDetail() {
      const orderDetail = "seller/order/" + this.$route.params.id;
      axios
        .get(orderDetail)
        .then((response) => {
          this.Skeleton = false;
          $(".placholderSwiper").remove();
          $("#cardPlus").remove();
          $(".vue-content-placeholders-text").remove();
          $(".vue-content-placeholders-img").remove();
          return response.data.data;
        })
        .then((data) => {
          this.rejectReason = data.rejectReason
          this.reasonTypeRejectOrder = data.reasonTypeRejectOrder
          // console.log(data.isUploadTax);
          this.complaintData = data.complaint;
          this.paymentHistory = data.paymentHistory;
          this.orderStatusId = data.orderStatusId;
          this.isProductUncategorized = data.isProductUncategorized
          this.isSendComplaint = data.isSendComplaint;
          //OrderWizard
          this.processingColumn = data.processing.column;
          this.processingData = data.processing.data;
          this.isNewOrder = data.processing.data;
          this.isUploadTax = data.isUploadTax;
          this.isTracking = data.isTracking;
          // console.log(data.isTracking);
          //End OrderWIzard
          //OrderHistory
          this.orderTimeline = data.orderHistory.reverse();
          this.statusDibatalkan = data.processing.column[7];
          //End OrderHistory
          //ConfirmPayment
          this.confirmPayment = data.confirmPayment;
          this.countConfirmPayment = Object.keys(data.confirmPayment).length;
          //End ConfirmPayment
          //sectionConfirmPayment
          this.sectionConfirmPayment = data.sectionConfirmPayment;
          this.countsectionConfirmPayment = Object.keys(
            data.sectionConfirmPayment
          ).length;
          //End sectionConfirmPayment
          //Doc
          this.printDocuments = data.printDocuments;
          this.eBastCount = Object.keys(data.eBast).length;
          // console.log(Object.keys(data.eBast).length)
          //End Doc
          //Invoice
          this.invoice = data.sectionOrderInformation;
          this.paymentMethod = data.sectionOrderInformation.paymentMethod;
          this.mall = data.sectionOrderInformation.mall;
          this.shipping = data.sectionOrderInformation.shipping;
          this.school = data.sectionOrderInformation.school;
          this.orderSummary = data.sectionProductInformation.items;
          this.itemsRequestChange =
            data.sectionProductInformation.itemsRequestChange;
          this.descriptionTotal =
            data.sectionProductInformation.descriptionTotal;
          this.orderSummaryCol = data.sectionProductInformation.column;

          //End Invoice
        })
        .then(() => {
          //for WizardPesanan
          const selectedAttrId = $(".tab-pane").attr("id");
          
          const select = selectedAttrId.charAt(selectedAttrId.length - 1) - 1;
          const handleLastArrow =
            this.processingColumn[this.processingColumn.length - 1].isActive;
          const matchSize = window.screen.availWidth;
          // console.log(matchSize);
          const options = {
            errorSteps: handleLastArrow === false ? [] : [7],
            // hiddenSteps: handleLastArrow === false ? [4] : [],
            // disabledSteps: handleLastArrow === false ? [4] : [],
            selected: select,
            justified: true,
            theme: matchSize < 376 ? "default" : "default",
            enableURLhash: false,
            transition: {
              animation: "fade",
              speed: "400",
              easing: "",
            },
            anchorSettings: {
              anchorClickable: false, // Enable/Disable anchor navigation
            },
            toolbarSettings: {
              showNextButton: false,
              showPreviousButton: false,
              toolbarExtraButtons: [],
            },
          };
          $("#smartwizard").smartWizard(options);
          setTimeout(() => {
            document.getElementsByClassName("tab-content")[0].style.cssText =
              "height: auto;";
          }, 1000);
          // this.imagePopup()
          imagePopup();
          // this.scrollComplaint();
          //ADDITIONAL
          if (this.statusDibatalkan.isActive) {
            $("#canceledOrder").addClass("animatedXfade text-primary") &&
              $(".basicOrder").removeClass("animatedXfade") &&
              $(".event-list").addClass("text-muted").removeClass("active");
          }
        })
        .catch((err) => {
          console.log(err)
          // this.$swal
          //   .fire({
          //     title: `<span style='font-size:17px'>Perhatian!</span>`,
          //     icon: "warning",
          //     html: "<span style='font-size:14px'>Invoice tidak ditemukan</span>",
          //     showCancelButton: false,
          //     confirmButtonColor: "#556ee6",
          //     focusConfirm: false,
          //     confirmButtonText: "Back",
          //   })
          //   .then((result) => {
          //     if (result.isConfirmed) {
          //       this.$router.push({
          //         path: "/pesanan",
          //       });
          //     }
          //   });
        });
    },
    alertIfHasComplain() {
      this.$swal
        .fire({
          title: `<span style='font-size:17px'>Perhatian!</span>`,
          icon: "warning",
          html: "<span style='font-size:14px'>Terdapat komplain yang belum diselesaikan.</span>",
          showCancelButton: false,
          confirmButtonColor: "#556ee6",
          focusConfirm: false,
          confirmButtonText: "Lihat Komplain",
        })
        .then((result) => {
          if (result.isConfirmed) {
            $("#complaintModal").modal("show");
            $("#complaintModal").on("shown.bs.modal", function () {
              setTimeout(() => {
                $(".scrollable")
                  .stop()
                  .animate(
                    {
                      scrollTop: $(".scrollable")[0].scrollHeight,
                    },
                    600
                  );
              }, 200);
            });
          }
        });
    },
    confirmOrder() {
      this.$swal
        .fire({
          title: `<span style='font-size:17px'>Anda Yakin?</span>`,
          text: "Anda memproses pesanan ini?",
          icon: "question",
          showCancelButton: true,
          width: 450,
          confirmButtonColor: "#556ee6",
          cancelButtonColor: "#f46a6a",
          cancelButtonText: "Tidak",
          confirmButtonText: "Ya",
        })
        .then((result) => {
          if (result.isConfirmed) {
            let timerInterval = timerInterval;
            this.$swal.fire({
              // title: `<span style='font-size:14px' >Mohon Tunggu</span>`,
              html: `<lottie-player s id="confirmPlayer" background="transparent"  speed="1.5"  style="width: 300px; height: 250px;"  loop  autoplay></lottie-player><h5 style="margin-top:-40px" class="mb-5">Sedang Diproses, Mohon tunggu...</h5>`,
              allowOutsideClick: true,
              showConfirmButton: false,
              allowEscapeKey: false,
              width: "auto",
              padding: "1em",
              // timer:3000,
              didOpen: () => {
                const player = document.querySelector("#confirmPlayer");
                player.load(this.animation.confirmOrder);
                // this.$swal.showLoading();
                timerInterval = setInterval(() => {
                  const content = this.$swal.getContent();
                  if (content) {
                    const b = content.querySelector("b");
                    if (b) {
                      b.textContent = this.$swal.getTimerLeft();
                    }
                  }
                }, 100);
              },
            });
            axios
              .put("seller/order/confirm", {
                id: this.$route.params.id,
              })
              .then(() => {
                this.$swal.close();
                this.$swal.fire({
                  // title: `<span style='font-size:17px'>Berhasil</span>`,
                  title: `<span style='font-size:14px' >Anda berhasil melakukan konfirmasi pesanan</span>`,
                  icon: "success",
                  // html: `<lottie-player src="https://assets6.lottiefiles.com/private_files/lf30_cp81xtth.json"  background="transparent"  speed="1.3"  style="width: 370px; height: 150px;"    autoplay></lottie-player><h5  class="mb-5">Anda berhasil melakukan konfirmasi pesanan</h5>`,
                  // allowOutsideClick: false,
                  // allowEscapeKey: false,
                  // width: 'auto',
                  padding: "1em",

                  showConfirmButton: false,
                  timer: 3000,
                });
                this.renderComponent = false;
                this.$nextTick(() => {
                  // Add the component back in
                  this.renderComponent = true;
                  this.getOrderDetail();
                });
              });
          }
        });
    },
    openModalRefuseOrder(){
      $('#modalRefuseOrder').modal('show')
    },
    refuseOrder() {
      const radioValue = $("input[name='reasonReject']:checked").val()
      if(radioValue){
         this.$swal
        .fire({
          title: `<span style='font-size:17px'>Anda Yakin?</span>`,
          text: "Anda menolak pesanan ini",
          icon: "warning",
          showCancelButton: true,
          width: 450,
          confirmButtonColor: "#556ee6",
          cancelButtonColor: "#f46a6a",
          cancelButtonText: "Tidak",
          confirmButtonText: "Ya",
        })
        .then((result) => {
          if (result.isConfirmed) {
            let timerInterval = timerInterval;
            this.$swal.fire({
              // title: `<span style='font-size:14px' >Mohon Tunggu</span>`,
              html: `<lottie-player  background="transparent" id="cancelPlayer" speed="1.5"  style="width: 100%; height: 200px; margin: 30px 0px 0px 30px;"  loop autoplay></lottie-player><h5 style="margin-top:-40px" class="mb-5">Sedang Diproses, Mohon tunggu...</h5>`,
              allowOutsideClick: true,
              showConfirmButton: false,
              allowEscapeKey: false,
              width: "auto",
              padding: "1em",
              // timer:3000,
              didOpen: () => {
                const player = document.querySelector("#cancelPlayer");
                player.load(this.animation.cancelOrder);
                // this.$swal.showLoading();
                timerInterval = setInterval(() => {
                  const content = this.$swal.getContent();
                  if (content) {
                    const b = content.querySelector("b");
                    if (b) {
                      b.textContent = this.$swal.getTimerLeft();
                    }
                  }
                }, 100);
              },
            });
            var radioValue = $("input[name='reasonReject']:checked").val();
            axios
              .put("seller/order/refuse", {
                id: this.$route.params.id,
                reasonType: radioValue,
              })
              .then(() => {
                setTimeout(() => {
                  this.$swal.fire({
                    title: `<span style='font-size:14px' >Anda berhasil menolak pesanan ini</span>`,
                    icon: "success",
                    // html: `<lottie-player src="https://assets6.lottiefiles.com/private_files/lf30_cp81xtth.json"  background="transparent"  speed="1.3"  style="width: 370px; height: 150px;"    autoplay></lottie-player><h5  class="mb-5">Anda berhasil menolak pesanan ini</h5>`,
                    // width: 'auto',
                    padding: "1em",

                    showConfirmButton: false,
                    timer: 3000,
                  });
                }, 500);
                this.$swal.close();
                this.renderComponent = false;
                this.$nextTick(() => {
                  // Add the component back in
                  this.renderComponent = true;
                  this.getOrderDetail();
                  $('#modalRefuseOrder').modal('hide')
                });
              });
          }
        });
      } else {
        this.$toast.error('Pilih alasan terlebih dahulu untuk menutup pesanan')
      }
    },
    putPrint(prints, url) {
      // console.log(prints,url)
      const openInNewTab = window.open(url, "_blank");
      openInNewTab.location;
      prints === ""
        ? ""
        : axios
            .put(`seller/order/${prints}`, {
              id: this.$route.params.id,
            })
            .then(() => {
              this.renderComponent = false;
              this.$nextTick(() => {
                this.renderComponent = true;
                this.getOrderDetail();
              });
            });
    },
    sendOrder() {
      this.$swal
        .fire({
          title: `<span style='font-size:17px'>Anda Yakin?</span>`,
          text: "Anda mengirim pesanan ini?",
          icon: "question",
          showCancelButton: true,
          width: 450,
          confirmButtonColor: "#556ee6",
          cancelButtonColor: "#f46a6a",
          cancelButtonText: "Tidak",
          confirmButtonText: "Ya",
        })
        .then((result) => {
          if (result.isConfirmed) {
            let timerInterval = timerInterval;
            this.$swal.fire({
              // title: `<span style='font-size:14px' >Mohon Tunggu</span>`,
              html: `<lottie-player id="sendPlayer"  background="transparent"  speed="1"  style="width: 300px; height: 250px;" autoplay loop></lottie-player><h5 style="margin-top:-40px"  class="mb-5">Sedang Diproses, Mohon tunggu...</h5>`,
              allowOutsideClick: true,
              showConfirmButton: false,
              allowEscapeKey: false,
              width: "auto",
              padding: "1em",
              // timer:3000,
              didOpen: () => {
                const player = document.querySelector("#sendPlayer");
                player.load(this.animation.sendOrder);
                // this.$swal.showLoading();
                timerInterval = setInterval(() => {
                  const content = this.$swal.getContent();
                  if (content) {
                    const b = content.querySelector("b");
                    if (b) {
                      b.textContent = this.$swal.getTimerLeft();
                    }
                  }
                }, 100);
              },
            });
            axios
              .put("seller/order/send", {
                id: this.$route.params.id,
                awb: $("#resi").val(),
              })
              .then(() => {
                this.$swal.close();
                this.$swal.fire({
                  title: `<span style='font-size:14px' >Anda berhasil mengirim pesanan ini</span>`,
                  icon: "success",
                  // html: `<lottie-player src="https://assets6.lottiefiles.com/private_files/lf30_cp81xtth.json"  background="transparent"  speed="1.3"  style="width: 370px; height: 150px;"    autoplay></lottie-player><h5  class="mb-5">Anda berhasil melakukan pengiriman pesanan</h5>`,
                  // allowOutsideClick: false,
                  // allowEscapeKey: false,
                  // width: 'auto',
                  padding: "1em",

                  showConfirmButton: false,
                  timer: 3000,
                });
                this.renderComponent = false;
                this.$nextTick(() => {
                  // Add the component back in
                  this.renderComponent = true;
                  this.getOrderDetail();
                });
              });
          }
        });
    },
    acceptRequestChange() {
      this.$swal
        .fire({
          title: `<span style='font-size:17px'>Anda Yakin?</span>`,
          text: "Anda menerima request perubahan pada pesanan ini",
          icon: "warning",
          showCancelButton: true,
          width: 450,
          confirmButtonColor: "#556ee6",
          cancelButtonColor: "#f46a6a",
          cancelButtonText: "Tidak",
          confirmButtonText: "Ya",
        })
        .then((result) => {
          if (result.isConfirmed) {
            let timerInterval = timerInterval;
            this.$swal.fire({
              // title: `<span style='font-size:14px' >Mohon Tunggu</span>`,
              html: `<lottie-player s id="confirmPlayer" background="transparent"  speed="1.5"  style="width: 300px; height: 250px;"  loop  autoplay></lottie-player><h5 style="margin-top:-40px" class="mb-5">Sedang Diproses, Mohon tunggu...</h5>`,
              allowOutsideClick: true,
              showConfirmButton: false,
              allowEscapeKey: false,
              width: "auto",
              padding: "1em",
              // timer:3000,
              didOpen: () => {
                const player = document.querySelector("#confirmPlayer");
                player.load(this.animation.confirmOrder);
                // this.$swal.showLoading();
                timerInterval = setInterval(() => {
                  const content = this.$swal.getContent();
                  if (content) {
                    const b = content.querySelector("b");
                    if (b) {
                      b.textContent = this.$swal.getTimerLeft();
                    }
                  }
                }, 100);
              },
            });
            axios
              .put("seller/order/acceptRequestChange", {
                id: this.$route.params.id,
              })
              .then(() => {
                setTimeout(() => {
                  this.$swal.fire({
                    title: `<span style='font-size:14px' >Anda berhasil menerima request perubahan pada pesanan ini</span>`,
                    icon: "success",
                    // html: `<lottie-player src="https://assets6.lottiefiles.com/private_files/lf30_cp81xtth.json"  background="transparent"  speed="1.3"  style="width: 370px; height: 150px;"    autoplay></lottie-player><h5  class="mb-5">Anda berhasil menolak pesanan ini</h5>`,
                    // width: 'auto',
                    padding: "1em",

                    showConfirmButton: false,
                    timer: 3000,
                  });
                }, 500);
                this.$swal.close();
                this.renderComponent = false;
                this.$nextTick(() => {
                  // Add the component back in
                  this.renderComponent = true;
                  this.getOrderDetail();
                });
              });
          }
        });
    },
    rejectRequestChange() {
      this.$swal
        .fire({
          title: `<span style='font-size:17px'>Anda Yakin?</span>`,
          text: "Anda menolak request perubahan pada pesanan ini",
          icon: "warning",
          showCancelButton: true,
          width: 450,
          confirmButtonColor: "#556ee6",
          cancelButtonColor: "#f46a6a",
          cancelButtonText: "Tidak",
          confirmButtonText: "Ya",
        })
        .then((result) => {
          if (result.isConfirmed) {
            let timerInterval = timerInterval;
            this.$swal.fire({
              // title: `<span style='font-size:14px' >Mohon Tunggu</span>`,
              html: `<lottie-player  background="transparent" id="cancelPlayer" speed="1.5"  style="width: 100%; height: 200px; margin: 30px 0px 0px 30px;"  loop autoplay></lottie-player><h5 style="margin-top:-40px" class="mb-5">Sedang Diproses, Mohon tunggu...</h5>`,
              allowOutsideClick: true,
              showConfirmButton: false,
              allowEscapeKey: false,
              width: "auto",
              padding: "1em",
              // timer:3000,
              didOpen: () => {
                const player = document.querySelector("#cancelPlayer");
                player.load(this.animation.cancelOrder);
                // this.$swal.showLoading();
                timerInterval = setInterval(() => {
                  const content = this.$swal.getContent();
                  if (content) {
                    const b = content.querySelector("b");
                    if (b) {
                      b.textContent = this.$swal.getTimerLeft();
                    }
                  }
                }, 100);
              },
            });
            axios
              .put("seller/order/rejectRequestChange", {
                id: this.$route.params.id,
              })
              .then(() => {
                setTimeout(() => {
                  this.$swal.fire({
                    title: `<span style='font-size:14px' >Anda berhasil menolak perubahan pada pesanan ini</span>`,
                    icon: "success",
                    // html: `<lottie-player src="https://assets6.lottiefiles.com/private_files/lf30_cp81xtth.json"  background="transparent"  speed="1.3"  style="width: 370px; height: 150px;"    autoplay></lottie-player><h5  class="mb-5">Anda berhasil menolak pesanan ini</h5>`,
                    // width: 'auto',
                    padding: "1em",

                    showConfirmButton: false,
                    timer: 3000,
                  });
                }, 500);
                this.$swal.close();
                this.renderComponent = false;
                this.$nextTick(() => {
                  // Add the component back in
                  this.renderComponent = true;
                  this.getOrderDetail();
                });
              });
          }
        });
    },
    acceptApplyCancel() {
      this.$swal
        .fire({
          title: "<span style='font-size:17px'>Anda Yakin?</span>",
          html: "<span style='font-size:15px'>Untuk menerima pembatalan pada pesanan ini?</span>",
          icon: "warning",
          showCancelButton: true,
          width: 450,
          confirmButtonColor: "#556ee6",
          cancelButtonColor: "#f46a6a",
          cancelButtonText: "Tidak",
          confirmButtonText: "Ya",
        })
        .then((result) => {
          if (result.isConfirmed) {
            let timerInterval = timerInterval;
            this.$swal.fire({
              title: "Pembatalan Pesanan",
              html: "Mohon Tunggu!",
              allowOutsideClick: false,
              allowEscapeKey: false,
              width: 350,
              didOpen: () => {
                this.$swal.showLoading();
                timerInterval = setInterval(() => {
                  const content = this.$swal.getContent();
                  if (content) {
                    const b = content.querySelector("b");
                    if (b) {
                      b.textContent = this.$swal.getTimerLeft();
                    }
                  }
                }, 100);
              },
            });
            this.paramId = this.$route.params.id;
            axios
              .put("seller/order/acceptApplyCancel", {
                id: this.$route.params.id,
              })
              .then(() => {
                setTimeout(() => {
                  this.$swal.fire({
                    title: `<span style='font-size:14px' >Anda berhasil menerima pembatalan pada pesanan ini</span>`,
                    icon: "success",
                    // html: `<lottie-player src="https://assets6.lottiefiles.com/private_files/lf30_cp81xtth.json"  background="transparent"  speed="1.3"  style="width: 370px; height: 150px;"    autoplay></lottie-player><h5  class="mb-5">Anda berhasil menolak pesanan ini</h5>`,
                    // width: 'auto',
                    padding: "1em",

                    showConfirmButton: false,
                    timer: 3000,
                  });
                }, 500);
                this.$swal.close();
                this.renderComponent = false;
                this.$nextTick(() => {
                  // Add the component back in
                  this.renderComponent = true;
                  this.getOrderDetail();
                });
              });
          }
        });
    },
    rejectApplyCancel() {
      this.$swal
        .fire({
          title: "<span style='font-size:17px'>Anda Yakin?</span>",
          html: "<span style='font-size:15px'>Untuk menolak pembatalan pada pesanan ini?</span>",
          icon: "warning",
          showCancelButton: true,
          width: 450,
          confirmButtonColor: "#556ee6",
          cancelButtonColor: "#f46a6a",
          cancelButtonText: "Tidak",
          confirmButtonText: "Ya",
        })
        .then((result) => {
          if (result.isConfirmed) {
            let timerInterval = timerInterval;
            this.$swal.fire({
              title: "Pembatalan Pesanan",
              html: "Mohon Tunggu!",
              allowOutsideClick: false,
              allowEscapeKey: false,
              width: 350,
              didOpen: () => {
                this.$swal.showLoading();
                timerInterval = setInterval(() => {
                  const content = this.$swal.getContent();
                  if (content) {
                    const b = content.querySelector("b");
                    if (b) {
                      b.textContent = this.$swal.getTimerLeft();
                    }
                  }
                }, 100);
              },
            });
            this.paramId = this.$route.params.id;
            axios
              .put("seller/order/rejectApplyCancel", {
                id: this.$route.params.id,
              })
              .then(() => {
                setTimeout(() => {
                  this.$swal.fire({
                    title: `<span style='font-size:14px' >Anda berhasil menolak pembatalan pada pesanan ini</span>`,
                    icon: "success",
                    // html: `<lottie-player src="https://assets6.lottiefiles.com/private_files/lf30_cp81xtth.json"  background="transparent"  speed="1.3"  style="width: 370px; height: 150px;"    autoplay></lottie-player><h5  class="mb-5">Anda berhasil menolak pesanan ini</h5>`,
                    // width: 'auto',
                    padding: "1em",

                    showConfirmButton: false,
                    timer: 3000,
                  });
                }, 500);
                this.$swal.close();
                this.renderComponent = false;
                this.$nextTick(() => {
                  // Add the component back in
                  this.renderComponent = true;
                  this.getOrderDetail();
                });
              });
          }
        });
    },
    getOrderTracking() {},
    openTracking() {
      $("#orderTrackingPlaceholder").css("display", "");
      this.isFetching = true;

      axios
        .get(`seller/order/tracking/${this.$route.params.id}`)
        .then((res) => {
          return res.data.data;
        })
        .then((data) => {
          this.orderTracking = data.reverse();
          // console.log(data);
        })
        .then(() => {
          this.isFetching = false;
          // this.isOpenTracking = false;
          $("#orderTrackingPlaceholder").hide();
          if (this.isOpenTracking) {
            this.isOpenTracking = false;
          } else {
            this.isOpenTracking = true;
          }
        });
    },
  },
};
</script>

<style scoped>
.btn-outline-default:hover{
  background-color: rgba(170, 170, 170, 0.829) !important;
}
input[type="file" i] {
  appearance: none;
  background-color: initial;
  cursor: default;
  align-items: baseline;
  color: inherit;
  text-overflow: ellipsis;
  white-space: pre;
  text-align: start !important;
  padding: initial;
  border: initial;
  overflow: hidden !important;
}

.input {
  -webkit-writing-mode: horizontal-tb !important;
  text-rendering: auto;
  color: -internal-light-dark(black, white);
  letter-spacing: normal;
  word-spacing: normal;
  text-transform: none;
  text-indent: 0px;
  text-shadow: none;
  display: inline-block;
  text-align: start;
  appearance: auto;
  background-color: -internal-light-dark(rgb(255, 255, 255), rgb(59, 59, 59));
  -webkit-rtl-ordering: logical;
  cursor: text;
  margin: 0em;
  font: 400 13.3333px Arial;
  padding: 1px 2px;
  border-width: 2px;
  border-style: inset;
  border-color: -internal-light-dark(rgb(118, 118, 118), rgb(133, 133, 133));
  border-image: initial;
}
.image-source-link {
  color: #98c3d1;
}


</style>